<template>
    <div class="search-input">
      <div class="games-search-input-box">
        <div class="games-search-input-main">
          <div class="games-search-icon">
            <i class="el-icon-search"></i>
          </div>
          <div class="games-search-text">
            <input
              style="width: 100%; height: 100%"
              v-model="goodsText"
              @focus="onFocus"
              @blur="onBlur"
              type="text"
              :placeholder="placeholder"
            />
          </div>
          <!-- <div class="games-search-btn">
            <div class="search" @click="search">search</div>
          </div> -->
        </div>
        <div class="Search-Funnel" v-if="funnel">
          <img @click="onfunnel" src="@/assets/mybox/search/funnel.png" />
        </div>
      </div>
      <!-- 动画 -->
      <Transition name="search">
        <div class="seach-list" v-if="isFocus">
          <div class="seach-li" @click="selected('暂无')" :key="key">
            <text-highlight :queries="queries">华为P60</text-highlight>
          </div>
        </div>
      </Transition>
    </div>
  </template>
  <script>
  export default {
    props: {
      placeholder: {
        type: String,
        default: "Search",
      },
      //是否禁用
      typeof: {
        type: Boolean,
        default: false,
      }, 
      value: {
        type: String,
        default: "",
      },
      //标签 默认搜索热门盒子
      label: {
        type: String,
        default: "hotBox",
      },
      //是否显示漏斗图
      funnel: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      value(val) {
        this.goodsText = val;
      },
      goodsText(val) {
        this.queries[0] = val;
        this.key++;
        console.log(this.queries);
      },
    },
    data() {
      return {
        searchGoods: "",
        key: 0,
        goodsText: this.value,
        queries: [], //高亮
        isFocus: false, //是否获取焦点
      };
    },
    //页面销毁前
    beforeDestroy() {
      this.$store.state.staking.funnel = false; //变回原始值
    },
    methods: {
      onFocus() {
        console.log("获取焦点");
        if (!this.typeof) {
        //   this.$router.push({
        //     path: "/SearchPage",
        //     query: { label: this.label, placeholder: "Search" },
        //   });
        this.$emit("OpenSearch");
        } else {
          this.isFocus = true;
        }
      },
      //点击搜索
      search() {
        if (!this.typeof) {
          console.log("禁用");
        } else {
          this.isFocus = false;
          this.$emit("Search", this.goodsText);
        }
      },
      //选中搜索
      selected(val) {
        this.isFocus = false;
        this.$emit("Search", val);
      },
      //失去焦点
      onBlur() {
        if (!this.typeof) {
        } else {
          this.search();
        }
      },
      //漏斗筛选 //在相应的组件里监听
      onfunnel() {
        this.$store.state.staking.funnel = !this.$store.state.staking.funnel;
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .search-input {
    position: relative;
  }
  .games-search-input-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .games-search-input-main {
      width: 100%;
      display: flex;
      height: 0.68rem;
      border-radius: 17px;
      border: 1px solid #303030;
      .games-search-icon {
        width: 12%;
        display: flex;
        font-size: 0.4rem;
        justify-content: center;
        align-items: center;
      }
  
      .games-search-text {
        width: 64%;
        font-size: 0.28rem;
      }
  
      .games-search-text input::placeholder {
        color: #c6c6c6;
      }
  
      .games-search-btn {
        width: 26%;
        font-size: 0.24rem;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
  
        .search {
          width: 1.36rem;
          text-align: center;
          line-height: 0.48rem;
          height: 0.48rem;
          background: #303030;
          border-radius: 17px;
        }
      }
    }
    .Search-Funnel {
      margin-left: 0.2rem;
    }
  }
  .seach-list {
    width: 100%;
    height: 100vh;
    overflow: auto;
    scrollbar-width: none;
    position: absolute;
    background: #ffffff;
    font-size: 0.24rem;
    text-align: left;
    z-index: 3;
    .seach-li {
      margin: 0.5rem 0;
    }
  }
  ::v-deep .text__highlight {
    color: #af6df7 !important;
    background: none !important;
  }
  /* //淡入淡出 */
  .search-enter-active,
  .search-leave-active {
    transition: opacity 0.5s;
  }
  .search-enter,
  .search-leave-to {
    opacity: 0;
  }
  </style>
  